<script lang="ts" setup>
import { memberConfig as rocnovelConfig } from './configs/rocnovel'
import { memberConfig as ocereadConfig } from './configs/oceread'
import { memberConfig as talewaveConfig } from './configs/talewave'
import { memberConfig as ficmoonConfig } from './configs/ficmoon'
import { memberConfig as novelarcConfig } from './configs/novelarc'
import { memberConfig as storyellaConfig } from './configs/storyella'
import { memberConfig as aurenovelConfig } from './configs/aurenovel'
import { memberConfig as florastoryConfig } from './configs/florastory'
import { memberConfig as silktaleConfig } from './configs/silktale'
import { memberConfig as pearlaConfig } from './configs/pearla'
import { memberConfig as fictoraConfig } from './configs/fictora'
import { memberConfig as marinovelConfig } from './configs/marinovel'
import { memberConfig as flipnovelConfig } from './configs/flipnovel'
import { memberConfig as moonpageConfig } from './configs/moonpage'
import { memberConfig as storlynConfig } from './configs/storlyn'
import { memberConfig as novarisConfig } from './configs/novaris'
import { memberConfig as noveluneConfig } from './configs/novelune'
import { memberConfig as novelmelloConfig } from './configs/novelmello'
import MemberPageDefault from './components/MemberPage.default.vue'
import MemberPageFicmoon from './components/MemberPage.ficmoon.vue'
import MemberPageNovelarc from './components/MemberPage.novelarc.vue'
import MemberPageAurenovel from './components/MemberPage.aurenovel.vue'
import MemberPageFlipnovel from './components/MemberPage.flipnovel.vue'
import MemberPageStorlyn from './components/MemberPage.storlyn.vue'
import MemberPageTalewave from './components/MemberPage.talewave.vue'
import MemberPageNovelmello from './components/MemberPage.novelmello.vue'
import { loadBrandComponent, loadBrandConfig } from '@/utils/loadBrandConfig'

// 🔥 加载当前品牌配置（构建时 tree-shaking）
const config = loadBrandConfig({
  rocnovel: rocnovelConfig,
  oceread: ocereadConfig,
  talewave: talewaveConfig,
  ficmoon: ficmoonConfig,
  novelarc: novelarcConfig,
  storyella: storyellaConfig,
  aurenovel: aurenovelConfig,
  florastory: florastoryConfig,
  silktale: silktaleConfig,
  pearla: pearlaConfig,
  fictora: fictoraConfig,
  marinovel: marinovelConfig,
  flipnovel: flipnovelConfig,
  moonpage: moonpageConfig,
  novelune: noveluneConfig,
  storlyn: storlynConfig,
  novaris: novarisConfig,
  novelmello: novelmelloConfig,
})

// 🔥 加载当前品牌组件（rocnovel 和 oceread 共用 default，ficmoon 和 novelarc 用专属组件）
const MemberPage = loadBrandComponent({
  rocnovel: MemberPageDefault,
  oceread: MemberPageDefault,
  ficmoon: MemberPageFicmoon,
  novelarc: MemberPageNovelarc,
  storyella: MemberPageNovelarc,
  aurenovel: MemberPageAurenovel,
  florastory: MemberPageNovelarc,
  silktale: MemberPageNovelarc,
  pearla: MemberPageNovelarc,
  fictora: MemberPageFicmoon,
  marinovel: MemberPageDefault,
  talewave: MemberPageTalewave,
  flipnovel: MemberPageFlipnovel,
  moonpage: MemberPageFlipnovel,
  novelune: MemberPageFlipnovel,
  storlyn: MemberPageStorlyn,
  novaris: MemberPageStorlyn,
  novelmello: MemberPageNovelmello,
})
</script>

<template>
  <div>
    <!-- 🔥 品牌专属页面组件 -->
    <MemberPage :config="config" />
  </div>
</template>
